import { ReactNode } from "react";

const COMBINING_MARKS_REGEX = /[̀-ͯ]/g;

const normalize = (str: string): string =>
    str.normalize("NFD").replace(COMBINING_MARKS_REGEX, "").toLowerCase();

function highlightMatches(text: string, query: string): ReactNode {
    const words = Array.from(
        new Set(query.trim().split(/\s+/).filter(Boolean).map(normalize))
    );

    if (!words.length) return text;

    const normalizedText = normalize(text);
    const ranges: [number, number][] = [];

    words.forEach((word) => {
        let fromIndex = 0;
        let matchIndex = normalizedText.indexOf(word, fromIndex);
        while (matchIndex !== -1) {
            ranges.push([matchIndex, matchIndex + word.length]);
            fromIndex = matchIndex + word.length;
            matchIndex = normalizedText.indexOf(word, fromIndex);
        }
    });

    if (!ranges.length) return text;

    ranges.sort((a, b) => a[0] - b[0]);
    const merged: [number, number][] = [];
    ranges.forEach(([start, end]) => {
        const last = merged[merged.length - 1];
        if (last && start <= last[1]) {
            last[1] = Math.max(last[1], end);
        } else {
            merged.push([start, end]);
        }
    });

    const parts: ReactNode[] = [];
    let cursor = 0;
    merged.forEach(([start, end], index) => {
        if (start > cursor) parts.push(text.slice(cursor, start));
        parts.push(<strong key={`${start}-${end}-${index}`}>{text.slice(start, end)}</strong>);
        cursor = end;
    });
    if (cursor < text.length) parts.push(text.slice(cursor));

    return parts;
}

export default highlightMatches;
